import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, isSupported } from 'firebase/messaging';

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBqxkAlD8bbLnfii6VzVCLKNd9vcjRiqv0",
  authDomain: "job-platform-906af.firebaseapp.com",
  projectId: "job-platform-906af",
  storageBucket: "job-platform-906af.firebasestorage.app",
  messagingSenderId: "710745856198",
  appId: "1:710745856198:web:7c7e429a0ca45da6d21fc7",
  measurementId: "G-GHYYHZ0NGE"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyANWdvOzNOubwl7nK9_krf65LRY8bcpw7Y",
//   authDomain: "harshal-jobs.firebaseapp.com",
//   projectId: "harshal-jobs",
//   storageBucket: "harshal-jobs.firebasestorage.app",
//   messagingSenderId: "212310483312",
//   appId: "1:212310483312:web:470bf443d9886c9b1b2fb5",
//   measurementId: "G-RQRXWQM0LK"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Initialize secondary app for creating users without affecting current session
const secondaryApp = initializeApp(firebaseConfig, 'Secondary');
const secondaryAuth = getAuth(secondaryApp);

// Initialize Firebase Messaging (only if supported)
let messaging = null;
isSupported().then((supported) => {
  
  if (supported) {
    messaging = getMessaging(app);
  }
}).catch((err) => {
  console.warn('Firebase Messaging not supported:', err);
});

export { auth, secondaryAuth, db, storage, messaging };
export default app;
